"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "dashboardCtrl",
    function (
      $scope,
      $q,
      model,
      chartData,
      Dashboard,
      PromotionRequest,
      permissionService,
      requiredApprovals
    ) {
      var vm = this;

      // Custom Chart.js positioner: always centres the tooltip vertically in the
      // plot area so it can never be clipped by top or bottom canvas edges.
      if (window.Chart && Chart.Tooltip && Chart.Tooltip.positioners) {
        Chart.Tooltip.positioners.chartMiddle = function (elements, position) {
          if (!elements.length) return false;
          var ca = this._chart.chartArea;
          return { x: position.x, y: (ca.top + ca.bottom) / 2 };
        };
      }

      vm.permissions = permissionService;
      vm.projectModule = config.projectModule;

      angular.extend($scope.$parent.vm, {
        title: null,
        insertUrl: null,
      });

      vm.model = model;

      var cd = chartData || {};

      vm.requiredApprovals = { rows: (requiredApprovals && requiredApprovals.rows) || [] };

      var defaultStart = moment().subtract(1, 'year').startOf('year').format('DD/MM/YYYY');
      var defaultEnd   = moment().format('DD/MM/YYYY');
      vm.filter = { startDate: defaultStart, endDate: defaultEnd };
      vm.activeRange = { startDate: defaultStart, endDate: defaultEnd };

      function toApiDate(val) {
        if (!val) return null;
        if (typeof val === 'string') return moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
        var ts = (typeof val === 'object' && val.pick != null) ? val.pick : val;
        return moment(ts).format('YYYY-MM-DD');
      }

      function toDisplayDate(val) {
        if (!val) return '';
        if (typeof val === 'string') return val;
        var ts = (typeof val === 'object' && val.pick != null) ? val.pick : val;
        return moment(ts).format('DD/MM/YYYY');
      }

      var PALETTE = [
        "#0067b2",
        "#ee4035",
        "#43A047",
        "#FB8C00",
        "#7B1FA2",
        "#00897B",
        "#F9A825",
        "#D81B60",
        "#4FC3F7",
        "#78909C"
      ];

      var percentPlugin = [{
        afterDatasetsDraw: function (chart) {
          var ctx = chart.ctx;
          chart.data.datasets.forEach(function (dataset, i) {
            var meta = chart.getDatasetMeta(i);
            if (meta.hidden) return;
            var total = dataset.data.reduce(function (a, b) { return a + b; }, 0);
            meta.data.forEach(function (element, index) {
              var value = dataset.data[index];
              if (!total || !value || (value / total) < 0.04) return;
              var pct = ((value / total) * 100).toFixed(0) + "%";
              var pos = element.tooltipPosition();
              ctx.save();
              ctx.font = "bold 11px \"Roboto Condensed\", Arial, sans-serif";
              ctx.fillStyle = "rgba(255,255,255,0.95)";
              ctx.textAlign = "center";
              ctx.textBaseline = "middle";
              ctx.fillText(pct, pos.x, pos.y);
              ctx.restore();
            });
          });
        }
      }];

      vm.fmt = function (val) {
        if (val == null) return "";
        if (val >= 1000000) return "R$ " + (val / 1000000).toFixed(1).replace(".", ",") + "M";
        if (val >= 1000)    return "R$ " + (val / 1000).toFixed(0) + "K";
        return "R$ " + val.toFixed(0);
      };

      function loadData(m, cd) {
        vm.model = m;

        vm.kpiTotalInvested    = m.totalInvested;
        vm.kpiTotalActions     = m.totalActions;
        vm.kpiAvgCostPerAction = m.avgCostPerAction;
        vm.hasKpiData = vm.kpiTotalInvested != null || vm.kpiTotalActions != null;

        var rawInvestByRegion = cd.investmentByRegion || [];
        rawInvestByRegion = rawInvestByRegion.slice().sort(function (a, b) { return b.value - a.value; });

        vm.investByRegionLabels  = rawInvestByRegion.map(function (r) { return r.name || ""; });
        vm.investByRegionData    = [rawInvestByRegion.map(function (r) { return r.value || 0; })];
        vm.investByRegionPalette = rawInvestByRegion.map(function (_, i) { return PALETTE[i % PALETTE.length]; });
        vm.investByRegionColors  = [{
          backgroundColor: rawInvestByRegion.map(function (_, i) { return PALETTE[i % PALETTE.length]; }),
          borderColor:     rawInvestByRegion.map(function (_, i) { return PALETTE[i % PALETTE.length]; })
        }];
        vm.investByRegionOptions = {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function (v) { return vm.fmt(v); }
              },
              gridLines: { color: "rgba(0,0,0,0.05)" }
            }],
            yAxes: [{ ticks: { fontSize: 11 } }]
          },
          tooltips: {
            callbacks: {
              label: function (ti) {
                return " R$ " + Number(ti.xLabel).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              }
            }
          },
          plugins: { datalabels: { display: false } }
        };
        vm.hasInvestByRegion = rawInvestByRegion.length > 0;

        var rawMonthlyEvolution = cd.monthlyEvolution || [];

        vm.monthlyEvolLabels  = rawMonthlyEvolution.map(function (e) { return e.month || ""; });
        vm.monthlyEvolSeries  = ["Valor Investido (R$)", "Qtd. de Ações"];
        vm.monthlyEvolData    = [
          rawMonthlyEvolution.map(function (e) { return e.value || 0; }),
          rawMonthlyEvolution.map(function (e) { return e.actions || 0; })
        ];
        vm.monthlyEvolColors = [
          { backgroundColor: "rgba(0,103,178,0.65)",  borderColor: "#0067b2", pointBackgroundColor: "#0067b2" },
          { backgroundColor: "rgba(238,64,53,0)",     borderColor: "#ee4035", pointBackgroundColor: "#ee4035", borderWidth: 2, pointRadius: 4 }
        ];
        vm.monthlyEvolDatasetOverride = [
          { type: "bar",  yAxisID: "y-value" },
          { type: "line", yAxisID: "y-actions", fill: false }
        ];
        vm.monthlyEvolOptions = {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                id: "y-value",
                position: "left",
                ticks: { callback: function (v) { return vm.fmt(v); } },
                gridLines: { color: "rgba(0,0,0,0.05)" }
              },
              {
                id: "y-actions",
                position: "right",
                gridLines: { drawOnChartArea: false },
                ticks: { stepSize: 1, beginAtZero: true }
              }
            ],
            xAxes: [{ gridLines: { display: false } }]
          },
          legend: { position: "bottom", labels: { fontSize: 11, boxWidth: 12 } },
          tooltips: {
            mode: "index", intersect: false,
            callbacks: {
              label: function (ti, d) {
                return ' ' + d.datasets[ti.datasetIndex].label + ': ' +
                  (ti.datasetIndex === 0 ? vm.fmt(ti.yLabel) : Math.round(ti.yLabel) + ' ações');
              }
            }
          },
          plugins: { datalabels: { display: false } }
        };
        vm.hasMonthlyEvol = rawMonthlyEvolution.length > 0;

        var rawByObjective = cd.distributionByObjective || [];

        vm.objectiveLabels  = rawByObjective.map(function (o) { return o.name || ""; });
        vm.objectiveData    = rawByObjective.map(function (o) { return o.value || 0; });
        vm.objectiveColors  = PALETTE.slice(0, rawByObjective.length);
        var objectiveTotal  = vm.objectiveData.reduce(function (a, b) { return a + b; }, 0);
        vm.objectivePct     = function (i) {
          return objectiveTotal > 0 ? ((vm.objectiveData[i] / objectiveTotal) * 100).toFixed(1) : "0.0";
        };
        vm.objectiveOptions = {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 58,
          legend: { display: false },
          tooltips: {
            callbacks: {
              label: function (ti, data) {
                var val   = data.datasets[0].data[ti.index];
                var total = data.datasets[0].data.reduce(function (a, b) { return a + b; }, 0);
                var pct   = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                return " " + data.labels[ti.index] + ": R$ " + Number(val).toLocaleString("pt-BR", { minimumFractionDigits: 2 }) + " (" + pct + "%)";
              }
            }
          },
          plugins: { datalabels: { display: false } }
        };
        vm.hasObjectives = rawByObjective.length > 0;
        vm.objectivePlugins = percentPlugin;

        var rawAudience = cd.audienceSegmentation || [];

        vm.audienceLabels  = rawAudience.map(function (s) { return s.name || ""; });
        vm.audienceData    = rawAudience.map(function (s) { return s.value || 0; });
        vm.audienceColors  = PALETTE.slice(0, rawAudience.length);
        var audienceTotal  = vm.audienceData.reduce(function (a, b) { return a + b; }, 0);
        vm.audiencePct     = function (i) {
          return audienceTotal > 0 ? ((vm.audienceData[i] / audienceTotal) * 100).toFixed(1) : "0.0";
        };
        vm.audienceOptions = {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          tooltips: {
            callbacks: {
              label: function (ti, data) {
                var val   = data.datasets[0].data[ti.index];
                var total = data.datasets[0].data.reduce(function (a, b) { return a + b; }, 0);
                var pct   = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                return " " + data.labels[ti.index] + ": " + pct + "%";
              }
            }
          },
          plugins: { datalabels: { display: false } }
        };
        vm.hasAudience = rawAudience.length > 0;
        vm.audiencePlugins = percentPlugin;

        var rawRanking = cd.ranking || [];
        rawRanking = rawRanking.map(function (r) { return { name: r.name, value: r.value || 0 }; });
        vm.rankingItems = rawRanking.slice(0, 10);
        vm.rankingTotal = vm.rankingItems.reduce(function (sum, r) { return sum + (r.value || 0); }, 0);
        vm.rankingPct = function (value) {
          return vm.rankingTotal > 0 ? ((value / vm.rankingTotal) * 100).toFixed(1) : "0.0";
        };

        var rawActionsByRegion = cd.actionsByRegion || [];
        rawActionsByRegion = rawActionsByRegion.slice().sort(function (a, b) { return b.quantity - a.quantity; });

        vm.actionsByRegionLabels  = rawActionsByRegion.map(function (r) { return r.name || ""; });
        vm.actionsByRegionData    = [rawActionsByRegion.map(function (r) { return r.quantity || 0; })];
        vm.actionsByRegionColors  = [{ backgroundColor: "#4FC3F7", borderColor: "#4FC3F7" }];
        vm.actionsByRegionOptions = {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          scales: {
            xAxes: [{ ticks: { stepSize: 1, beginAtZero: true }, gridLines: { color: "rgba(0,0,0,0.05)" } }],
            yAxes: [{ ticks: { fontSize: 11 } }]
          },
          tooltips: {
            callbacks: {
              label: function (ti) { return " " + ti.xLabel + " ações"; }
            }
          },
          plugins: { datalabels: { display: false } }
        };
        vm.hasActionsByRegion = rawActionsByRegion.length > 0;

        var rawMonthlyBySegment = cd.monthlyValueBySegment || [];

        var segmentNames = [];
        rawMonthlyBySegment.forEach(function (m) {
          Object.keys(m.segments || {}).forEach(function (s) {
            if (segmentNames.indexOf(s) < 0) segmentNames.push(s);
          });
        });

        vm.monthlySegmentLabels  = rawMonthlyBySegment.map(function (m) { return m.month || ""; });
        vm.monthlySegmentSeries  = segmentNames;
        vm.monthlySegmentData    = segmentNames.map(function (s) {
          return rawMonthlyBySegment.map(function (m) {
            var segs = m.segments || {};
            return segs[s] || 0;
          });
        });
        vm.monthlySegmentColors  = segmentNames.map(function (_, i) {
          return { backgroundColor: PALETTE[i % PALETTE.length] };
        });
        vm.monthlySegmentOptions = {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{ stacked: true, gridLines: { display: false } }],
            yAxes: [{
              stacked: true,
              ticks: { callback: function (v) { return vm.fmt(v); } },
              gridLines: { color: "rgba(0,0,0,0.05)" }
            }]
          },
          legend: { position: "bottom", labels: { fontSize: 11, boxWidth: 12 } },
          tooltips: {
            mode: "index", intersect: false,
            callbacks: { label: function (ti, d) { return ' ' + d.datasets[ti.datasetIndex].label + ': ' + vm.fmt(ti.yLabel); } }
          },
          plugins: { datalabels: { display: false } }
        };
        vm.hasMonthlySegment = rawMonthlyBySegment.length > 0;

        vm.monthlyInvestByYearData = fillChartData(
          cd.monthlyInvestmentByYear,
          '0, 103, 178',
          '238, 64, 53'
        );
        vm.hasMonthlyInvestByYear = !!(vm.monthlyInvestByYearData.data && vm.monthlyInvestByYearData.data.length);
      }

      function fillChartData(dataSource, colorBar, colorLine) {
        if (!dataSource || !dataSource.series || !dataSource.series.length) return {};

        var years = dataSource.series.map(function(y) { return parseInt(y); });
        var maxYear = Math.max.apply(null, years);

        var generateLineColor = function(index) {
          var base = colorLine.split(', ').map(Number);
          var inc  = index * 40;
          return [(base[0] + inc) % 256, (base[1] + inc) % 256, (base[2] + inc) % 256].join(', ');
        };

        var legend = dataSource.series.map(function(yearStr, i) {
          var year = parseInt(yearStr);
          if (year === maxYear) {
            return { name: yearStr, color: 'rgba(' + colorBar + ', 0.4)', border: 'rgba(' + colorBar + ', 1)' };
          }
          var lc = generateLineColor(i);
          return { name: yearStr, color: 'rgba(' + lc + ', 1)', border: 'rgba(' + lc + ', 1)' };
        });

        var datasetOverride = dataSource.series.map(function(yearStr) {
          var year = parseInt(yearStr);
          if (year === maxYear) {
            return { type: 'bar', backgroundColor: 'rgba(' + colorBar + ', 0.4)', borderColor: 'rgba(' + colorBar + ', 1)', borderWidth: 1 };
          }
          var entry = legend.filter(function(s) { return s.name === yearStr; })[0];
          var lc = entry.border.replace('rgba(', '').replace(')', '').split(', ').slice(0, 3).join(', ');
          return {
            type: 'line', fill: false, clip: true,
            borderColor: 'rgba(' + lc + ', 1)', backgroundColor: 'rgba(' + lc + ', 0.2)',
            pointBorderColor: 'rgba(' + lc + ', 1)', pointBackgroundColor: '#fff',
            pointHoverBackgroundColor: 'rgba(' + lc + ', 1)', pointHoverBorderColor: 'rgba(' + lc + ', 1)',
            yAxisID: 'y-axis-1'
          };
        });

        return {
          labels: dataSource.labels,
          series: dataSource.series,
          data: dataSource.data,
          legend: legend,
          datasetOverride: datasetOverride,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: { display: false },
            scales: {
              xAxes: [{ gridLines: { display: false } }],
              yAxes: [{
                id: 'y-axis-1', type: 'linear', position: 'left',
                ticks: { beginAtZero: true, callback: function(v) { return vm.fmt(v); } },
                gridLines: { color: 'rgba(0,0,0,0.05)' }
              }]
            },
            tooltips: {
              mode: 'index', intersect: false,
              callbacks: { label: function (ti, d) { return ' ' + d.datasets[ti.datasetIndex].label + ': ' + vm.fmt(ti.yLabel); } }
            },
            plugins: { datalabels: { display: false } }
          }
        };
      }

      // ── KPI section loaders ──────────────────────────────────────────────────

      function loadRoi(params) {
        vm.loadingRoi = true;
        Dashboard.roi(params || {}).$promise
          .then(function (data) {
            if (!data) return;
            vm.roiSummary = data.summary || {};

            var raw = data.monthly || [];
            vm.roiLabels  = raw.map(function (m) { return m.mes; });
            vm.hasRoi     = raw.length > 0;

            vm.roiData    = [raw.map(function (m) { return m.roiMedio || 0; })];
            vm.roiSeries  = ['Estimativa de ROI (%)'];
            vm.roiColors  = [{ backgroundColor: 'rgba(0,103,178,0.08)', borderColor: '#0067b2', pointBackgroundColor: '#0067b2', borderWidth: 2, pointRadius: 4 }];
            vm.roiOptions = {
              responsive: true, maintainAspectRatio: false,
              scales: {
                xAxes: [{ gridLines: { display: false } }],
                yAxes: [{ ticks: { callback: function (v) { return v + '%'; } }, gridLines: { color: 'rgba(0,0,0,0.05)' } }]
              },
              legend: { display: false },
              tooltips: { callbacks: { label: function (ti) { return ' Estimativa de ROI: ' + parseFloat(ti.yLabel).toFixed(2) + '%'; } } },
              plugins: { datalabels: { display: false } }
            };

            vm.roiRevenueData    = [
              raw.map(function (m) { return m.investimentoTotal || 0; }),
              raw.map(function (m) { return m.receitaAdicionalTotal || 0; })
            ];
            vm.roiRevenueSeries  = ['Investido (R$)', 'Receita Adicional (R$)'];
            vm.roiRevenueColors  = [
              { backgroundColor: 'rgba(0,103,178,0.65)', borderColor: '#0067b2' },
              { backgroundColor: 'rgba(67,160,71,0.65)', borderColor: '#43a047' }
            ];
            vm.roiRevenueOptions = {
              responsive: true, maintainAspectRatio: false,
              scales: {
                xAxes: [{ gridLines: { display: false } }],
                yAxes: [{ ticks: { callback: function (v) { return vm.fmt(v); } }, gridLines: { color: 'rgba(0,0,0,0.05)' } }]
              },
              legend: { position: 'bottom', labels: { fontSize: 11, boxWidth: 12 } },
              tooltips: {
                mode: 'index', intersect: false,
                callbacks: { label: function (ti, d) { return ' ' + d.datasets[ti.datasetIndex].label + ': ' + vm.fmt(ti.yLabel); } }
              },
              plugins: { datalabels: { display: false } }
            };
          })
          .catch(angular.noop)
          .finally(function () { vm.loadingRoi = false; });
      }

      function loadFunnel(params) {
        vm.loadingFunnel = true;
        Dashboard.funnel(params || {}).$promise
          .then(function (data) {
            if (!data) return;
            var rawC = data.completionRate || [];
            vm.funnelLabels  = rawC.map(function (m) { return m.mesCriacao; });
            vm.funnelData    = [
              rawC.map(function (m) { return m.concluidas || 0; }),
              rawC.map(function (m) { return Math.max(0, (m.emAndamentoOuConcluidas || 0) - (m.concluidas || 0)); }),
              rawC.map(function (m) { return m.canceladas || 0; })
            ];
            vm.funnelSeries  = ['Concluídas', 'Em Andamento', 'Canceladas'];
            vm.funnelColors  = [
              { backgroundColor: 'rgba(67,160,71,0.75)' },
              { backgroundColor: 'rgba(0,103,178,0.65)' },
              { backgroundColor: 'rgba(238,64,53,0.65)' }
            ];
            vm.funnelOptions = {
              responsive: true, maintainAspectRatio: false,
              scales: {
                xAxes: [{ stacked: true, gridLines: { display: false } }],
                yAxes: [{ stacked: true, ticks: { stepSize: 1, beginAtZero: true }, gridLines: { color: 'rgba(0,0,0,0.05)' } }]
              },
              legend: { position: 'bottom', labels: { fontSize: 11, boxWidth: 12 } },
              tooltips: {
                mode: 'index', intersect: false,
                callbacks: { label: function (ti, d) { return ' ' + d.datasets[ti.datasetIndex].label + ': ' + Math.round(ti.yLabel); } }
              },
              plugins: { datalabels: { display: false } }
            };
            vm.hasFunnel = rawC.length > 0;

            vm.overdueByRegion    = data.overdueByRegion || [];
            vm.hasOverdue         = vm.overdueByRegion.length > 0;
            vm.overdueInvestTotal = vm.overdueByRegion.reduce(function (s, r) { return s + (r.investimentoEmRisco || 0); }, 0);
          })
          .catch(angular.noop)
          .finally(function () { vm.loadingFunnel = false; });
      }

      function loadApproval(params) {
        vm.loadingApproval = true;
        Dashboard.approval(params || {}).$promise
          .then(function (data) {
            if (!data) return;

            var rawSteps  = data.approvalTimeByStep || [];
            var stepNames = [], stepMonths = [];
            rawSteps.forEach(function (r) { if (stepNames.indexOf(r.etapa) < 0) stepNames.push(r.etapa); });
            rawSteps.forEach(function (r) { if (stepMonths.indexOf(r.mes) < 0) stepMonths.push(r.mes); });
            vm.approvalTimeLabels  = stepMonths;
            vm.approvalTimeSeries  = stepNames;
            vm.approvalTimeData    = stepNames.map(function (step) {
              return stepMonths.map(function (mes) {
                var row = rawSteps.filter(function (r) { return r.etapa === step && r.mes === mes; })[0];
                return row ? (row.tempoMedioHoras || 0) : null;
              });
            });
            vm.approvalTimeColors  = stepNames.map(function (_, i) { return { backgroundColor: PALETTE[i % PALETTE.length] }; });
            vm.approvalTimeOptions = {
              responsive: true, maintainAspectRatio: false,
              scales: {
                xAxes: [{ gridLines: { display: false } }],
                yAxes: [{ ticks: { callback: function (v) { return v + 'h'; } }, gridLines: { color: 'rgba(0,0,0,0.05)' } }]
              },
              legend: { position: 'bottom', labels: { fontSize: 11, boxWidth: 12 } },
              tooltips: {
                enabled: false, mode: 'index', intersect: false,
                callbacks: { label: function (ti, d) { return ' ' + d.datasets[ti.datasetIndex].label + ': ' + ti.yLabel + 'h'; } },
                custom: function (model) {
                  var el = document.getElementById('tm-kpi05');
                  if (!el) {
                    el = document.createElement('div');
                    el.id = 'tm-kpi05';
                    el.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;background:rgba(0,0,0,0.75);color:#fff;font-size:11px;padding:8px 10px;border-radius:4px;white-space:nowrap;transition:opacity .1s;';
                    document.body.appendChild(el);
                  }
                  if (model.opacity === 0) { el.style.opacity = '0'; return; }
                  var html = model.title && model.title.length ? '<div style="font-weight:600;margin-bottom:4px">' + model.title[0] + '</div>' : '';
                  model.body.forEach(function (b, i) {
                    var bg = model.labelColors[i].backgroundColor;
                    html += '<div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:' + bg + ';margin-right:4px;vertical-align:middle"></span>' + b.lines[0] + '</div>';
                  });
                  el.innerHTML = html;
                  var r = this._chart.canvas.getBoundingClientRect();
                  var x = r.left + model.caretX + 12;
                  var y = r.top + model.caretY - el.offsetHeight / 2;
                  if (y < 8) y = 8;
                  if (y + el.offsetHeight > window.innerHeight - 8) y = window.innerHeight - 8 - el.offsetHeight;
                  if (x + el.offsetWidth > window.innerWidth - 8) x = r.left + model.caretX - el.offsetWidth - 12;
                  el.style.top = y + 'px';
                  el.style.left = x + 'px';
                  el.style.opacity = '1';
                }
              },
              plugins: { datalabels: { display: false } }
            };
            vm.hasApprovalTime = rawSteps.length > 0;

            var rawRate = data.rejectionRate || [];
            vm.rejectionRateLabels  = rawRate.map(function (r) { return r.mes; });
            vm.rejectionRateData    = [rawRate.map(function (r) { return r.taxaRejeicao || 0; })];
            vm.rejectionRateSeries  = ['Taxa de Rejeição (%)'];
            vm.rejectionRateColors  = [{ backgroundColor: 'rgba(238,64,53,0)', borderColor: '#ee4035', pointBackgroundColor: '#ee4035', borderWidth: 2, pointRadius: 4 }];
            vm.rejectionRateOptions = {
              responsive: true, maintainAspectRatio: false,
              scales: {
                xAxes: [{ gridLines: { display: false } }],
                yAxes: [{ ticks: { callback: function (v) { return v + '%'; } }, gridLines: { color: 'rgba(0,0,0,0.05)' } }]
              },
              legend: { display: false },
              tooltips: { callbacks: { label: function (ti) { return ' Rejeição: ' + parseFloat(ti.yLabel).toFixed(2) + '%'; } } },
              plugins: { datalabels: { display: false } }
            };
            vm.hasRejectionRate = rawRate.length > 0;

            var rawReasons = (data.rejectionReasons || []).slice(0, 8);
            vm.rejectionReasonLabels  = rawReasons.map(function (r) { return r.motivo; });
            vm.rejectionReasonData    = [rawReasons.map(function (r) { return r.ocorrencias || 0; })];
            vm.rejectionReasonColors  = [{ backgroundColor: '#EE4035', borderColor: '#EE4035' }];
            vm.rejectionReasonOptions = {
              responsive: true, maintainAspectRatio: false,
              legend: { display: false },
              scales: {
                xAxes: [{ ticks: { stepSize: 1, beginAtZero: true }, gridLines: { color: 'rgba(0,0,0,0.05)' } }],
                yAxes: [{ ticks: { fontSize: 11 } }]
              },
              tooltips: { callbacks: { label: function (ti) { return ' ' + ti.xLabel + ' ocorrências'; } } },
              plugins: { datalabels: { display: false } }
            };
            vm.hasRejectionReasons = rawReasons.length > 0;

            vm.multipleRejections    = data.multipleRejections || {};
            vm.hasMultipleRejections = !!(vm.multipleRejections.totalComReprovacao);
          })
          .catch(angular.noop)
          .finally(function () { vm.loadingApproval = false; });
      }

      function loadSellers(params) {
        vm.loadingSellers = true;
        Dashboard.sellers(params || {}).$promise
          .then(function (data) {
            vm.sellers    = data || [];
            vm.hasSellers = vm.sellers.length > 0;
          })
          .catch(angular.noop)
          .finally(function () { vm.loadingSellers = false; });
      }

      function loadSegmentation(params) {
        vm.loadingSegmentation = true;
        Dashboard.segmentation(params || {}).$promise
          .then(function (data) {
            if (!data) return;

            var rawCust = data.customerType || [];
            var custTypes = [], custMonths = [];
            rawCust.forEach(function (r) { if (custTypes.indexOf(r.tipoCliente) < 0) custTypes.push(r.tipoCliente); });
            rawCust.forEach(function (r) { if (custMonths.indexOf(r.mes) < 0) custMonths.push(r.mes); });
            vm.custTypeLabels  = custMonths;
            vm.custTypeSeries  = custTypes;
            vm.custTypeData    = custTypes.map(function (t) {
              return custMonths.map(function (m) {
                var row = rawCust.filter(function (r) { return r.tipoCliente === t && r.mes === m; })[0];
                return row ? (row.totalInvestido || 0) : 0;
              });
            });
            vm.custTypeColors  = custTypes.map(function (_, i) { return { backgroundColor: PALETTE[i % PALETTE.length] }; });
            vm.custTypeOptions = {
              responsive: true, maintainAspectRatio: false,
              scales: {
                xAxes: [{ stacked: true, gridLines: { display: false } }],
                yAxes: [{ stacked: true, ticks: { callback: function (v) { return vm.fmt(v); } }, gridLines: { color: 'rgba(0,0,0,0.05)' } }]
              },
              legend: { position: 'bottom', labels: { fontSize: 11, boxWidth: 12 } },
              tooltips: {
                mode: 'index', intersect: false,
                callbacks: { label: function (ti, d) { return ' ' + d.datasets[ti.datasetIndex].label + ': ' + vm.fmt(ti.yLabel); } }
              },
              plugins: { datalabels: { display: false } }
            };
            vm.hasCustType = rawCust.length > 0;

            var rawSellout = data.sellout || [];
            var selloutTypes = [], selloutMonths = [];
            rawSellout.forEach(function (r) { if (selloutTypes.indexOf(r.tipoAcao) < 0) selloutTypes.push(r.tipoAcao); });
            rawSellout.forEach(function (r) { if (selloutMonths.indexOf(r.mes) < 0) selloutMonths.push(r.mes); });
            vm.selloutLabels  = selloutMonths;
            vm.selloutSeries  = selloutTypes;
            vm.selloutData    = selloutTypes.map(function (t) {
              return selloutMonths.map(function (m) {
                var row = rawSellout.filter(function (r) { return r.tipoAcao === t && r.mes === m; })[0];
                return row ? (row.totalInvestido || 0) : 0;
              });
            });
            vm.selloutColors  = [
              { backgroundColor: 'rgba(0,103,178,0.65)', borderColor: '#0067b2' },
              { backgroundColor: 'rgba(238,64,53,0.65)', borderColor: '#ee4035' }
            ];
            vm.selloutOptions = {
              responsive: true, maintainAspectRatio: false,
              scales: {
                xAxes: [{ gridLines: { display: false } }],
                yAxes: [{ ticks: { callback: function (v) { return vm.fmt(v); } }, gridLines: { color: 'rgba(0,0,0,0.05)' } }]
              },
              legend: { position: 'bottom', labels: { fontSize: 11, boxWidth: 12 } },
              tooltips: {
                mode: 'index', intersect: false,
                callbacks: { label: function (ti, d) { return ' ' + d.datasets[ti.datasetIndex].label + ': ' + vm.fmt(ti.yLabel); } }
              },
              plugins: { datalabels: { display: false } }
            };
            vm.hasSellout = rawSellout.length > 0;

            var rawMargin = data.margin || [];
            var marginTypes = [], marginMonths = [];
            rawMargin.forEach(function (r) { if (marginTypes.indexOf(r.tipoAcao) < 0) marginTypes.push(r.tipoAcao); });
            rawMargin.forEach(function (r) { if (marginMonths.indexOf(r.mes) < 0) marginMonths.push(r.mes); });
            vm.marginLabels  = marginMonths;
            vm.marginSeries  = marginTypes;
            vm.marginData    = marginTypes.map(function (t) {
              return marginMonths.map(function (m) {
                var row = rawMargin.filter(function (r) { return r.tipoAcao === t && r.mes === m; })[0];
                return row ? (row.margemMedia || 0) : 0;
              });
            });
            vm.marginColors  = marginTypes.map(function (_, i) { return { backgroundColor: PALETTE[i % PALETTE.length] }; });
            vm.marginOptions = {
              responsive: true, maintainAspectRatio: false,
              scales: {
                xAxes: [{ gridLines: { display: false } }],
                yAxes: [{ ticks: { callback: function (v) { return vm.fmt(v); } }, gridLines: { color: 'rgba(0,0,0,0.05)' } }]
              },
              legend: { position: 'bottom', labels: { fontSize: 11, boxWidth: 12 } },
              tooltips: {
                mode: 'index', intersect: false,
                callbacks: { label: function (ti, d) { return ' ' + d.datasets[ti.datasetIndex].label + ': ' + vm.fmt(ti.yLabel); } }
              },
              plugins: { datalabels: { display: false } }
            };
            vm.hasMargin = rawMargin.length > 0;

            var rawProforma = data.proforma || [];
            vm.proformaLabels  = rawProforma.map(function (r) { return r.mes; });
            vm.proformaData    = [
              rawProforma.map(function (r) { return r.valorSolicitado || 0; }),
              rawProforma.map(function (r) { return r.valorNF || 0; })
            ];
            vm.proformaSeries  = ['Valor Aprovado (R$)', 'Valor NF (R$)'];
            vm.proformaColors  = [
              { backgroundColor: 'rgba(0,103,178,0)', borderColor: '#0067b2', pointBackgroundColor: '#0067b2', borderWidth: 2, pointRadius: 4 },
              { backgroundColor: 'rgba(67,160,71,0)', borderColor: '#43a047', pointBackgroundColor: '#43a047', borderWidth: 2, pointRadius: 4 }
            ];
            vm.proformaOptions = {
              responsive: true, maintainAspectRatio: false,
              scales: {
                xAxes: [{ gridLines: { display: false } }],
                yAxes: [{ ticks: { callback: function (v) { return vm.fmt(v); } }, gridLines: { color: 'rgba(0,0,0,0.05)' } }]
              },
              legend: { position: 'bottom', labels: { fontSize: 11, boxWidth: 12 } },
              tooltips: {
                mode: 'index', intersect: false,
                callbacks: { label: function (ti, d) { return ' ' + d.datasets[ti.datasetIndex].label + ': ' + vm.fmt(ti.yLabel); } }
              },
              plugins: { datalabels: { display: false } }
            };
            vm.hasProforma = rawProforma.length > 0;

            var rawRev = data.revenueBySegment || [];
            var revSegs = [], revMonths = [];
            rawRev.forEach(function (r) { if (revSegs.indexOf(r.segmento) < 0) revSegs.push(r.segmento); });
            rawRev.forEach(function (r) { if (revMonths.indexOf(r.mes) < 0) revMonths.push(r.mes); });
            vm.revenueSegLabels  = revMonths;
            vm.revenueSegSeries  = revSegs;
            vm.revenueSegData    = revSegs.map(function (seg) {
              return revMonths.map(function (m) {
                var row = rawRev.filter(function (r) { return r.segmento === seg && r.mes === m; })[0];
                return row ? (row.receitaAdicional || 0) : 0;
              });
            });
            vm.revenueSegColors  = revSegs.map(function (_, i) { return { backgroundColor: PALETTE[i % PALETTE.length] }; });
            vm.revenueSegOptions = {
              responsive: true, maintainAspectRatio: false,
              scales: {
                xAxes: [{ stacked: true, gridLines: { display: false } }],
                yAxes: [{ stacked: true, ticks: { callback: function (v) { return vm.fmt(v); } }, gridLines: { color: 'rgba(0,0,0,0.05)' } }]
              },
              legend: { position: 'bottom', labels: { fontSize: 11, boxWidth: 12 } },
              tooltips: {
                mode: 'index', intersect: false,
                callbacks: { label: function (ti, d) { return ' ' + d.datasets[ti.datasetIndex].label + ': ' + vm.fmt(ti.yLabel); } }
              },
              plugins: { datalabels: { display: false } }
            };
            vm.hasRevenueSeg = rawRev.length > 0;
          })
          .catch(angular.noop)
          .finally(function () { vm.loadingSegmentation = false; });
      }

      loadData(model, cd);

      var kpiParams = { startDate: toApiDate(vm.filter.startDate), endDate: toApiDate(vm.filter.endDate) };
      loadRoi(kpiParams);
      loadFunnel(kpiParams);
      loadApproval(kpiParams);
      loadSellers(kpiParams);
      loadSegmentation(kpiParams);

      vm.isFiltering = false;
      vm.applyFilter = function () {
        if (vm.isFiltering) return;
        vm.isFiltering = true;

        var params = {
          startDate: toApiDate(vm.filter.startDate),
          endDate:   toApiDate(vm.filter.endDate)
        };

        $q.all([
          Dashboard.dashboard(params).$promise,
          Dashboard.dashboardCharts(params).$promise.catch(function () { return {}; }),
          PromotionRequest.list({
            page:             1,
            pageSize:         1000,
            requiresApproval: true
          }).$promise.catch(function () { return { rows: [] }; })
        ]).then(function (results) {
          loadData(results[0], results[1]);
          vm.requiredApprovals = { rows: (results[2] && results[2].rows) || [] };
          vm.activeRange = { startDate: toDisplayDate(vm.filter.startDate), endDate: toDisplayDate(vm.filter.endDate) };
        }).finally(function () {
          vm.isFiltering = false;
        });

        loadRoi(params);
        loadFunnel(params);
        loadApproval(params);
        loadSellers(params);
        loadSegmentation(params);
      };
    }
  );
